export const language: any ={
    LabelCarts:"Shopping Cart",
    Material:"Material",
    nodata: "No data in cart",
}

